import styled from 'styled-components'

export const Container = styled.div`
    position: relative;
    padding: 20px;
    h1 {
        font-size: 16px;
        color: #333;
        font-family: 'Inter';
        font-weight: 500;
        /* margin-bottom: 30px; */
    }

    .pagination {
        display: flex;
        justify-content: center;
    }
`

export const ExtractFilter = styled.div`
    display: flex;
    flex-direction: column;
    gap: 14px;
    @media (min-width: 720px) {
        gap: 30px;
    }
    .top-bar {
        display: flex;
        flex-direction: column;
        gap: 14px;

        h1 {
            font-size: 20px;
            color: #333;
            font-family: 'Inter';
            font-weight: 500;
        }

        .right-side {
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 10px;
        }

        @media (min-width: 720px) {
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            gap: 0px;

            .right-side {
                flex-direction: row;
                align-items: center;
                justify-content: initial;
            }
        }

        @media (max-width: 478px) {
            .payment-button {
                display: none;
            }
        }
    }

    .bottom-bar {
        display: flex;
        flex-direction: column-reverse;
        gap: 14px;

        .select {
            display: flex;
            gap: 10px;
        }

        .right-side {
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 10px;
        }

        @media (min-width: 720px) {
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            gap: 0px;

            .right-side {
                justify-content: initial;
                .react-datepicker-wrapper {
                    width: auto;
                }
            }
        }
    }
`

export const FilterContainer = styled.div`
    /* width: 100vw; */
    /* overflow: auto; */
    /* background: rgba(0, 0, 0, 0.2); */
    /* border-radius: 6px; */
    /* position: absolute; */
    /* z-index: 9; */
    /* top: calc(40px + 10px); */
    /* right: 10px; */
    /* min-width: 300px; */
    /* max-width: 350px; */
    display: grid;
    grid-template-rows: 54px 1fr 70px;
    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
    background: #fff;
    position: fixed;
    z-index: 10;
    top: 0;
    right: 0;
    width: 300px;
    border-radius: 6px 0px 0px 6px;

    /* padding: 10px; */

    header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        /* border-bottom: 1px solid #d3d3d3; */
        padding: 10px;

        p {
            font-size: 20px;
            /* font-family: 'Poppins', sans-serif; */
        }
    }

    form {
        padding: 10px;
        .input-group {
        }

        .input-wrapper {
            /* display: flex; */
            /* align-items: center; */
            margin-bottom: 30px;
        }
    }

    .actions.modal {
        padding: 10px;
        display: flex;
        align-items: center;
        justify-content: flex-end;
    }

    @media (min-width: 678px) {
        /* right: 100px; */
        /* min-width: 500px; */
        /* top: 0; */
        /* right: 0; */
        /* display: flex;
        flex-direction: column;
        justify-content: space-between; */
        /* height: 100vh; */
        height: 100%;
        width: 500px;
    }
`
export const Option = styled.span``

export const Title = styled.div`
    border-bottom: 1px solid #d3d3d3;
    margin-bottom: 15px;
    h1 {
        margin-top: 10px;
        margin-bottom: 10px;
        color: #333;
        font-family: 'Inter';
        font-weight: 500;
        font-size: 20px;
    }
`

export const Filtros = styled.div`
    background: #fff;
    padding: 15px 10px 15px 10px;
    /* box-shadow: rgba(0, 0, 0, 0.05) 0px 6px 24px 0px,
        rgba(0, 0, 0, 0.08) 0px 0px 0px 1px; */
    /* border-radius: 10px 10px 0px 0px; */
    border-top: 1px solid #d3d3d3;
    overflow: auto;

    p {
        font-size: 16px;
        font-family: 'Inter';
        font-weight: 500;
        margin-bottom: 30px;
        border-bottom: 1px solid #d3d3d3;
    }
    form {
        min-width: 500px;
        .input-group {
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 10px;
            margin-bottom: 20px;
        }

        .input-wrapper {
            display: flex;
            flex-direction: column;
            /* align-items: center; */
            /* gap: 10px; */
            font-family: 'Roboto';
            font-weight: 400;
            font-size: 1rem;
            line-height: 1.4375em;
            /* @media (min-width: 500px) {
                flex-direction: row;
                align-items: center;
            } */
            label {
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                /* margin-right: 5px; */
                color: rgba(0, 0, 0, 0.6);
            }

            .date {
                height: 40px;
                padding: 6px 8px;
                border: 1px solid #d3d3d3;
                border-radius: 6px;
                font-size: 17px;
                color: #333;
                cursor: pointer;
            }
            .MuiTextField-root {
                .MuiOutlinedInput-root {
                    height: 40px;
                }
            }
        }

        .actions {
            display: flex;
            align-items: center;
            justify-content: flex-end;
            padding: 10px 0;
            border-top: 1px solid #d3d3d3;

            button {
                display: flex;
                align-items: center;
                /* font-family: 'Roboto'; */
                /* font-weight: 500; */
                gap: 4px;
                /* background: #1976d2; */
                /* color: #fff; */
                /* padding: 6px 10px; */
                /* text-transform: uppercase; */
                /* border-radius: 6px; */
                /* cursor: pointer; */
            }
        }
    }
`

export const Contracts = styled.div`
    /* padding: 0 10px; */
    margin-top: 30px;
    border-radius: 10px;
    background: #fff;
    box-shadow: rgba(0, 0, 0, 0.05) 0px 6px 24px 0px,
        rgba(0, 0, 0, 0.08) 0px 0px 0px 1px;
    margin-bottom: 40px;
    overflow: auto;
`

export const Header = styled.div`
    padding: 15px 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-width: 1000px;
    position: relative;

    .left {
        display: flex;
        align-items: center;
        gap: 14px;
    }

    .title {
        h2 {
            font-family: 'Roboto';
            font-weight: 500;
            font-size: 20px;
        }
    }

    .exports {
        /* display: flex;
        align-items: center;
        gap: 10px; */
        background: #333;
        position: absolute;
        top: calc(40px + 10px);
        right: 0;
        width: 150px;
        z-index: 2;

        border-radius: 6px;
        box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;

        ul {
            display: flex;
            flex-direction: column;
        }

        .button-exports {
            display: flex;
            align-items: center;
            gap: 10px;
            color: #d3d3d3;
            padding: 10px;
            border-bottom: 1px solid #d3d3d3;
            width: 100%;

            &:hover {
                color: #fff;
            }
        }
    }

    .button {
        display: flex;
        align-items: center;
        gap: 4px;
        font-family: 'Poppins';
        font-weight: 500;
        color: #3c363b;
        border: 1px solid #d3d3d3;
        padding: 4px 6px;
        border-radius: 8px;
        cursor: pointer;

        svg {
            color: #6d756a;
        }
    }
`

export const HistoricoTable = styled.table`
    padding: 10px;
    table-layout: fixed;
    border-collapse: collapse;
    width: 100%;
    min-width: 1000px;
    thead {
        padding: 0 10px;
        border-bottom: 1px solid #d3d3d3;
        border-top: 1px solid #d3d3d3;
        /* background: #f8fafc; */

        th {
            color: #333;
            color: #a8a39d;
            font-weight: 400;
            font-family: 'Inter';
            font-size: 14px;
            padding: 10px 0;
            height: 63px;
            /* width: min-content; */
        }

        th:first-child {
            width: 50px;
            padding: 0 10px;
        }
        /* 
    th.valor {
      width: 10%;
    } */

        /* th:last-child {
      width: 40px;
    }  */

        th.tipo {
            width: 80px;
        }

        th.categoria {
            width: 30px;
        }

        th.adq {
            width: 166px;
        }

        th.valor {
        }

        th.recebedor {
            width: 128px;
        }
    }

    tbody {
        tr:not(tr:last-child) {
            border-bottom: 1px solid #d3d3d3;
        }

        tr > td {
            /* color: #333;
      font-family: 'Inter';
      font-weight: 400; */
            &.negative {
                /* color: red; */
            }
            /* width: max-content; */
        }
        td:first-child {
            width: 50px;
            padding: 0 10px;
        }

        td:nth-child(7) {
            width: 120px;
        }

        tr {
            cursor: pointer;

            &:hover {
                background: rgba(0, 157, 221, 0.1);
            }
        }

        .arrow {
            display: flex;
            align-items: center;
            justify-content: center;
            border: 1px solid #d3d3d3;
            background: #fff;
            border-radius: 8px;
            padding: 4px;
            transition: transform 0.2s ease-in;
            transform: rotate(180deg);
            cursor: pointer;
        }
        .arrow.down {
            svg {
                transform: rotate(180deg);
            }
        }
    }

    td,
    th {
        padding: 15px 0;
        text-align: left;
    }

    .order {
        display: inline-flex;
        align-items: center;
        gap: 3px;
        transform: rotate(0deg);
        transition: transform 0.2s ease-in;
        cursor: pointer;
    }

    .order.desc {
        svg {
            transform: rotate(180deg);
        }
    }

    tfoot {
        border-top: 1px solid #d3d3d3;
        font-family: 'Inter';
        font-weight: 400;
    }
    /* 
  .valorLivre {
    display: flex;
    align-items: center;
    gap: 3px;
    transform: rotate(0deg);
    transition: transform .2s ease-in;
    cursor: pointer;
  } */

    /* .valorLivre.desc {
    svg {
      transform: rotate(180deg);
    }
  } */
    /* 
  .checkbox {
    width: 16px;
    height: 16px;
    cursor: pointer;
  } */

    /* td.edit {
    width: 10%;
   > span {
     white-space: nowrap;
     padding: 3px 5px;
     border: 1px solid #D3D3D3;
     border-radius: 6px;
     font-size: 13px;
     font-weight: 500;
     cursor: pointer;
      &:hover {
        color: #566583;
      }
   }
  } */
`
